<script setup lang="ts">
  defineOptions({
    name: 'CPTabPane',
    inheritAttrs: false,
    __TAB_PANE__: true,
  })

  import { computed, useSlots, type PropType, type VNode, type VNodeChild } from 'vue'

  import { HLTabPane } from '@platform-ui/highrise'

  const props = defineProps({
    name: {
      type: [String, Number] as PropType<string | number>,
      required: true,
    },
    tab: {
      type: [String, Number, Object, Function] as PropType<string | number | VNode | (() => VNodeChild)>,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tabKey: {
      type: [String, Number] as PropType<string | number>,
      required: true,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    /** Merged onto the tab trigger node (e.g. `id` for a11y / tests). */
    tabProps: {
      type: Object as PropType<Record<string, unknown>>,
      default: undefined,
    },
  })

  const slots = useSlots()

  const tabContent = computed(() => slots.tab ?? props.tab)
</script>

<template>
  <HLTabPane
    v-bind="$attrs"
    :name="props.name"
    :tab="tabContent"
    :tab-key="props.tabKey"
    :icon-only="props.iconOnly"
    :disabled="props.disabled"
    :tab-props="props.tabProps"
  >
    <slot />
  </HLTabPane>
</template>
